var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8469 5.98009L9.34688 0.980094C9.24417 0.911569 9.12347 0.875 9 0.875C8.87653 0.875 8.75583 0.911569 8.65312 0.980094L1.15313 5.98009C1.06751 6.03722 0.997324 6.1146 0.948805 6.20537C0.900285 6.29614 0.874933 6.39748 0.875 6.50041V14.6254C0.875 14.9569 1.0067 15.2749 1.24112 15.5093C1.47554 15.7437 1.79348 15.8754 2.125 15.8754H15.875C16.2065 15.8754 16.5245 15.7437 16.7589 15.5093C16.9933 15.2749 17.125 14.9569 17.125 14.6254V6.50041C17.1251 6.39748 17.0997 6.29614 17.0512 6.20537C17.0027 6.1146 16.9325 6.03722 16.8469 5.98009ZM6.55625 10.8754L2.125 14.0004V7.71369L6.55625 10.8754ZM7.83516 11.5004H10.1648L14.5891 14.6254H3.41094L7.83516 11.5004ZM11.4438 10.8754L15.875 7.71369V14.0004L11.4438 10.8754ZM9 2.25119L15.3992 6.51759L10.1648 10.2504H7.83672L2.60234 6.51759L9 2.25119Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopIcon);
export default __webpack_public_path__ + "static/media/envelopIcon.51cdb3ae7bf795876591350fd36c3f2f.svg";
export { ForwardRef as ReactComponent };